import { useState } from "react";
import GlobalContext from "./GlobalContext";

const GlobalComponent = (props) => {
  const [logoutModal, setLogoutModal] = useState(false);
  const [editableUserId, setEditableUserId] = useState(undefined);
  const [editableUser, setEditableUser] = useState(undefined);
  const [settingsDropdown, setSettingsDropdown] = useState(false);
  const [catetoryIconUptated, setCatetoryIconUptated] = useState(false);
  const [INHumberger, setINHumberger] = useState(undefined);
  const [logoUpload, setLogoUpload] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [chatModal, setChatModal] = useState(false);
  const [showMenu, setShowMenu] = useState(true);

  return (
    <GlobalContext.Provider
      value={{
        logoutModal,
        setLogoutModal,
        editableUserId,
        setEditableUserId,
        editableUser,
        setEditableUser,
        settingsDropdown,
        setSettingsDropdown,
        INHumberger,
        setINHumberger,
        catetoryIconUptated,
        setCatetoryIconUptated,
        logoUpload,
        setLogoUpload,
        notificationCount,
        setNotificationCount,
        chatModal,
        setChatModal,

        showMenu,
        setShowMenu,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};

export default GlobalComponent;
